var map = {
	"./aleksa_0.jpg": 927,
	"./aleksa_1.jpg": 922,
	"./aleksa_2.jpg": 261,
	"./aleksa_3.jpg": 0,
	"./aleksa_5.jpg": 374,
	"./tika_logo.ico": 817,
	"./tika_logo.png": 660,
	"./tika_logo_one.png": 41,
	"./tika_main_logo.png": 2
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 517;